import $ from 'jquery';
import {RefreshOptions} from '../postFormData';

export class CartMessage {
  static frontend(el: HTMLElement, opt: any) {
    return new CartMessage();
  }

  static updated(instance, oldEl, newEl, options: RefreshOptions = {}) {
    const style = {
      position: 'fixed',
      top: '50%',
      left: '50%',
      width: '640px',
      'max-width': '85vw',
      'z-index': 20000,
      transform: 'translate(-50%, -50%)',
      'box-shadow': '#888 0 0 32px 5px',
    };
    if (!options?.hideStatus) {
      const $newEl = $(newEl);
      $newEl.find('script').each((i, el) => {
        try {
          eval(el.innerHTML);
        } catch (e) {
          console.error('Error running custom script block');
          console.error(e);
        }
        $(el).remove();
      });
      const $toast = $newEl.children();

      $(oldEl).empty().append($toast);
      $toast.css(style);
      $toast.fadeIn(700, () => {
        setTimeout(() => {
          $toast.fadeOut(700, () => {
            $toast.detach();
          });
        }, 1500);
      });
    }
  }
}
